import React from "react";
import { Form } from "antd";
import { InputText } from "@comps/components";
import { getErrorProps } from "@utils/helpers";
import TextArea from "antd/es/input/TextArea";

const ClinicForm = ({ onFinish, initialData, formName, errors, setErrors }) => {


  return (
    <Form
      // Vertical, like every other form in the app. This one was the odd
      // one out at layout="horizontal" with no labelCol, so antd sized
      // each label to its own text and the three fields started at three
      // different left edges.
      layout="vertical"
      name={ formName }
      onFinish={ onFinish }
      initialValues={ initialData }
    >
      <Form.Item onChange={
        () => setErrors([])
      } name="name" rules={ rules.name } label="Name :" className="da-mb-16"
        { ...getErrorProps(errors['name']) }
      >
        <InputText placeholder="Enter clinic name" />
      </Form.Item>
      <Form.Item onChange={
        () => setErrors([])
      } name="phone" rules={ rules.phone } label="Phone :" className="da-mb-16"
        { ...getErrorProps(errors['phone']) }
      >
        <InputText placeholder="Enter clinic phone number" />
      </Form.Item>
      <Form.Item onChange={
        () => setErrors([])
      } name="address" rules={ rules.address } label="Address :" className="da-mb-16"
        { ...getErrorProps(errors['address']) }
      >
        <TextArea placeholder="Enter clinic address" />
      </Form.Item>
    </Form>
  )
}


const rules = {
  name: [
    { required: true, message: 'Please enter the clinic name.', },
    { min: 3, message: 'Minimum name length is 3', },
    { max: 100, message: 'Maximum name length is 100', },
  ]
};


export default ClinicForm;